import { render, staticRenderFns } from "./BannerIcon.vue?vue&type=template&id=538d818c&scoped=true"
import script from "./BannerIcon.vue?vue&type=script&lang=js"
export * from "./BannerIcon.vue?vue&type=script&lang=js"
import style0 from "./BannerIcon.vue?vue&type=style&index=0&id=538d818c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d818c",
  null
  
)

export default component.exports